module.exports = __webpack_public_path__ + "img/esg-G.2417284b.svg";